export default __webpack_public_path__ + "locales/nl/InfoPanel.json?hash=ed7feb65a3baa38aa6b1c041024f3449";